/**
 *
 * @param {User} tenant
 * @param {string} searchString
 * @returns
 */
export const searchTenantByString = (tenant, searchString) => {
  if (searchString) {
    const search = new RegExp(
      `^${searchString.toLowerCase()}|(?<=\\s)${searchString.toLowerCase()}`,
      'i'
    ) // same regex in the back-end searching
    const username = tenant.username ? tenant.username.toLowerCase() : ''
    const firstName = tenant.firstName ? tenant.firstName.toLowerCase() : ''
    const lastName = tenant.lastName ? tenant.lastName.toLowerCase() : ''
    const email = tenant.email1 ? tenant.email1.toLowerCase() : ''
    const alias =
      tenant.alias && tenant.alias.name ? tenant.alias.name.toLowerCase() : ''
    return (
      (username && username.search(search) > -1) ||
      (firstName && firstName.search(search) > -1) ||
      (lastName && lastName.search(search) > -1) ||
      (email && email.search(search) > -1) ||
      (alias && alias.search(search) > -1)
    )
  } else {
    return true
  }
}
